import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconHeadset",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6 1.75a4 4 0 0 0-4 4v2.5H1v-2.5a5 5 0 1 1 10 0v3a2.5 2.5 0 0 1-2.5 2.5h-3a1 1 0 0 1-1-1v-.5a1.5 1.5 0 1 1 3 0v.5h1a1.5 1.5 0 0 0 1.5-1.5v-3a4 4 0 0 0-4-4Zm.5 8.5v-.5a.5.5 0 0 0-1 0v.5h1Zm-3-4.5v2.5h-1v-2.5h1Zm6 0v2.5h-1v-2.5h1Z",
  fill: "currentColor"
}, null, -1), h = [
  _
];
function m(e, v, i, u, f, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--headset"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Headset",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const I = /* @__PURE__ */ l(o, [["render", m]]);
export {
  I as default
};
//# sourceMappingURL=headset.js.map
